@use "../../sass/global/global" as *;

.ux-iws-nb-contact-info {
    display: block;
    margin: 20px 30px 50px;

    [slot="headline"] {
        @include nb-heading(6, true);
        margin: 0 !important;
        color: $color-black-1;
    }

    &__details {
        margin-top: 30px;
    }

    a[slot="details"] {
        @include font(light);
        font-size: 14px;
        color: #005074 !important;
        text-decoration: underline !important;
        display: block;
        width: max-content;
        margin-bottom: 4px;
    }

    a[slot="details"]:hover {
        color: #131313 !important;
    }
}
